import {
  Box,
  Button,
  Flex,
  Image,
  Text,
  VStack,
  Heading,
  Grid,
  GridItem,
} from '@ritualco/jutsu'
import { FullWidthPage } from '../../components/PageTemplates'
import { useContent } from '../../lib/content/react'
import { HomeProps } from './types'
import Invite from 'assets/Images/Invite.png'
import { useStore } from 'state/store'
import { useHistory } from 'lib/router'

export const Home = ({
  step1,
  step2,
  step3,
  onLinkClick = () => {},
}: HomeProps) => {
  const { formatMessage } = useContent()
  const history = useHistory()
  const userName = useStore(state => state.userInfo.firstName)

  return (
    <FullWidthPage
      heading={formatMessage(
        { id: 'pmportal.home.heading' },
        { name: userName }
      )}
      subheading={formatMessage({ id: 'pmportal.home.subheading' })}
      showDivider
    >
      <Flex justify="center" mt={6}>
        <Flex
          direction="column"
          align={'center'}
          gridGap={3}
          border={'0px solid black'}
        >
          <Box
            border="1px solid"
            borderColor="grayscale.quinary"
            borderRadius="lg"
            p={8}
            width={'100%'}
          >
            <VStack spacing={4} textAlign="center">
              <VStack>
                <Image src={Invite} width="auto" height="auto" mb={3} />

                <Text
                  color="grayscale.tertiary"
                  fontSize="small"
                  mb={1}
                  fontWeight="semibold"
                  textTransform="uppercase"
                >
                  {formatMessage({ id: 'pmportal.home.step1.step' })}
                </Text>
                <Heading>{formatMessage({ id: step1.title })}</Heading>
              </VStack>

              <Text>{formatMessage({ id: step1.text })}</Text>
              <Button onClick={() => onLinkClick(step1.linkName)}>
                {formatMessage({ id: step1.linkLabel })}
              </Button>
            </VStack>
          </Box>
          <Grid templateColumns="repeat(2, 1fr)" gridColumnGap={12} mt={8}>
            <GridItem colSpan={1}>
              <VStack spacing={4} alignItems="start">
                <VStack alignItems="start" spacing={1}>
                  <Text
                    color="grayscale.tertiary"
                    fontSize="small"
                    fontWeight="semibold"
                    textTransform="uppercase"
                  >
                    {formatMessage({ id: 'pmportal.home.step2.step' })}
                  </Text>
                  <Heading>{formatMessage({ id: step2.title })}</Heading>
                </VStack>

                <Text>{formatMessage({ id: step2.text })}</Text>
                <Button
                  variant="link"
                  onClick={() => onLinkClick(step2.linkName)}
                >
                  {formatMessage({ id: step2.linkLabel })}
                </Button>
              </VStack>
            </GridItem>
            <GridItem colSpan={1}>
              <VStack spacing={4} alignItems="start">
                <VStack alignItems="start" spacing={1}>
                  <Text
                    color="grayscale.tertiary"
                    fontSize="small"
                    fontWeight="semibold"
                    textTransform="uppercase"
                  >
                    {formatMessage({ id: 'pmportal.home.step3.step' })}
                  </Text>
                  <Heading>{formatMessage({ id: step3.title })}</Heading>
                </VStack>

                <Text>{formatMessage({ id: step3.text })}</Text>
                <Button
                  variant="link"
                  onClick={() => onLinkClick(step3.linkName)}
                >
                  {formatMessage({ id: step3.linkLabel })}
                </Button>
              </VStack>
            </GridItem>
          </Grid>
        </Flex>
      </Flex>
    </FullWidthPage>
  )
}
